
import { defineComponent, computed, PropType } from 'vue'

// 从分组节点中提取 { 分组名, factors: [{ 因子名, attrDesc, options }] }
function buildTree(group: any): any[] {
  const result: any[] = []
  if (!group?.childAttrList) return result

  for (const child of group.childAttrList) {
    if (child.attrType !== null && child.attrType !== undefined) {
      // 直接是因子，归到一个匿名分组，没有说明的跳过
      if (!hasDesc(child)) continue
      const last = result[result.length - 1]
      const anon = last?._anon ? last : null
      if (anon) {
        anon.factors.push(buildFactor(child))
      } else {
        result.push({ attrCode: group.attrCode + '_anon', attrName: group.attrName, _anon: true, factors: [buildFactor(child)] })
      }
    } else {
      // 子分组，只保留有说明的因子
      const factors: any[] = []
      for (const f of (child.childAttrList || [])) {
        if (f.attrType !== null && f.attrType !== undefined && hasDesc(f)) {
          factors.push(buildFactor(f))
        }
      }
      if (factors.length) {
        result.push({ attrCode: child.attrCode, attrName: child.attrName, factors })
      }
    }
  }
  return result
}

function buildFactor(f: any) {
  return {
    attrCode: f.attrCode,
    attrName: f.attrName,
    attrDesc: f.attrDesc || '',
    options: (f.childAttrList || []).filter((o: any) => o.attrDesc)
  }
}

function hasDesc(f: any): boolean {
  if (f.attrDesc) return true
  return (f.childAttrList || []).some((o: any) => o.attrDesc)
}

export default defineComponent({
  name: 'FactorDescDialog',
  props: {
    visible: Boolean,
    tabNode: { type: Object as PropType<any>, default: null },
    isLight: Boolean,
    colors: { type: Object as PropType<Record<string, string>>, required: true }
  },
  emits: ['close'],
  setup(props) {
    const tree = computed(() => props.tabNode ? buildTree(props.tabNode) : [])
    return { tree }
  }
})
